import { hoverFromPoint, toCellBox } from "/src/features/stageEditor/hitTest.ts";
import { once, pointerCoords } from "/src/features/stageEditor/pointerEnd.ts";

const MOVE_PX = 8;

function boxes(grid) {
  return [...grid.children].map((cell) => {
    const box = cell.getBoundingClientRect();
    return toCellBox(Number(cell.dataset.x), Number(cell.dataset.y), box);
  });
}

function targetAt(grid, trash, clientX, clientY) {
  return hoverFromPoint(
    boxes(grid),
    trash.getBoundingClientRect(),
    clientX,
    clientY,
    grid.getBoundingClientRect(),
  );
}

export function bindDrag(el, payload, grid, trash, preview, onHover, onDrop, onStart, onTap) {
  el.addEventListener("pointerdown", (event) => {
    if (event.button !== 0) return;
    event.stopPropagation();
    event.preventDefault();
    el.setPointerCapture(event.pointerId);
    const origin = { x: event.clientX, y: event.clientY };
    let last = { x: event.clientX, y: event.clientY };
    let dragging = false;
    const move = (next) => {
      last = { x: next.clientX, y: next.clientY };
      const dx = next.clientX - origin.x;
      const dy = next.clientY - origin.y;
      if (!dragging && dx * dx + dy * dy < MOVE_PX * MOVE_PX) return;
      if (!dragging) {
        dragging = true;
        onStart?.(payload);
      }
      if (payload.mode === "link") {
        preview.hidden = true;
      } else {
        preview.hidden = false;
        preview.style.left = `${next.clientX}px`;
        preview.style.top = `${next.clientY}px`;
      }
      onHover(targetAt(grid, trash, next.clientX, next.clientY), payload, next.clientX, next.clientY);
    };
    const finish = once(() => {
      preview.hidden = true;
      preview.removeAttribute("style");
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", end);
      document.removeEventListener("pointercancel", end);
      el.removeEventListener("lostpointercapture", end);
      window.removeEventListener("blur", end);
    });
    const end = (next) => {
      const point = pointerCoords(
        { x: next?.clientX ?? 0, y: next?.clientY ?? 0 },
        last,
      );
      finish();
      if (dragging) onDrop(payload, targetAt(grid, trash, point.x, point.y));
      else if (next?.type === "pointerup") onTap?.(payload);
    };
    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", end);
    document.addEventListener("pointercancel", end);
    el.addEventListener("lostpointercapture", end);
    window.addEventListener("blur", end);
  });
}
